module.exports = __webpack_public_path__ + "static/media/mitten.0085c94a.svg";